// Module
var code = "<div v-if=\"form && field && form.validation[field] != ''\" :class=\"'validation ' + addlClass\"> <ul> <li>{{ form.validation[field] }}</li> </ul> </div> ";
// Exports
export default code;